import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Campo Unidade/Organização: aceita selecionar existente (autocomplete) OU digitar livre.
// Evita duplicatas com grafias diferentes sugerindo a unidade já cadastrada equivalente.
export function UnidadeInput({ value, onChange, opcoes = [], testid = "unidade-input", label = "Unidade / Organização", className = "" }) {
  const listId = `${testid}-list`;
  const v = (value || "").trim();
  const near = v ? opcoes.find((u) => (u.nome || "").trim().toLowerCase() === v.toLowerCase() && (u.nome || "").trim() !== v) : null;

  return (
    <div className={className}>
      {label !== null && <Label>{label}</Label>}
      <Input
        data-testid={testid}
        list={listId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Selecione ou digite (ex.: 27º BPM, BOPE, CPRV)"
        autoComplete="off"
      />
      <datalist id={listId}>
        {opcoes.map((u) => <option key={u.id || u} value={u.nome || u} />)}
      </datalist>
      {near && (
        <button
          type="button"
          data-testid={`${testid}-sugestao`}
          onClick={() => onChange(near.nome)}
          className="mt-1 text-xs text-primary hover:underline"
        >
          Já existe "{near.nome}" — usar esta?
        </button>
      )}
    </div>
  );
}
